export default __webpack_public_path__ + "static/media/digma-forms.2d981b33.png";